import { render, staticRenderFns } from "./Replacements.vue?vue&type=template&id=76d53252&scoped=true&"
import script from "./Replacements.vue?vue&type=script&lang=js&"
export * from "./Replacements.vue?vue&type=script&lang=js&"
import style0 from "./Replacements.vue?vue&type=style&index=0&id=76d53252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d53252",
  null
  
)

component.options.__file = "Replacements.vue"
export default component.exports